import { toast } from 'react-toastify';

import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestOperacaoDrenos({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'drenos', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* store({ payload }) {
  try {
    const { operacaodreno, params } = payload;

    yield call(api.post, 'drenos', operacaodreno);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/operacaodreno');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* find({ payload }) {
  try {
    const { id } = payload;

    const { data } = yield call(api.get, `drenos/${id}`);

    yield put(successRequest(data));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* update({ payload }) {
  try {
    const { operacaodreno, params } = payload;

    yield call(api.put, 'drenos', operacaodreno);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/operacaodreno');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* remove({ payload }) {
  try {
    const { id, params } = payload;
    yield call(api.delete, `drenos/${id}`);
    yield put(successRemove({ ...params, pesquisalista: true }));
    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) { yield put(failedRequest()); erros.map((error) => toast.error(error)); }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;

    const response = yield call(api.get, 'drenos', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* applyUpdate({ payload }) {
  try {
    const { data, params } = payload;

    yield call(api.put, 'drenos', data);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/operacaodreno');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export default all([
  takeLatest(
    '@operacaodreno/OPERACAOMEDICAOTEMPERATURAS_IN_REQUEST',
    requestOperacaoDrenos
  ),
  takeLatest(
    '@operacaodreno/DELETE_OPERACAOMEDICAOTEMPERATURA',
    remove
  ),
  takeLatest(
    '@operacaodreno/SUCCESS_REMOVE',
    requestOperacaoDrenos
  ),
  takeLatest(
    '@operacaodreno/STORE_OPERACAOMEDICAOTEMPERATURA',
    store
  ),
  takeLatest(
    '@operacaodreno/FIND_OPERACAOMEDICAOTEMPERATURA',
    find
  ),
  takeLatest(
    '@operacaodreno/UPDATE_OPERACAOMEDICAOTEMPERATURA',
    update
  ),
  takeLatest('@operacaodreno/RECORD_FILTERING', applyedFilters),
  takeLatest('@operacaodreno/UPDATE', applyUpdate),
]);



